import Raven from 'raven-js';

// Context: https://git.hubteam.com/HubSpot/payments-checkout-issues/issues/1795
// For custom domains the hublet and env need to be overridden when setting up the paymentsClient
export async function fetchHubletForCustomDomain() {
  if (window.__hcmsHubletPromise) {
    try {
      const resp = await window.__hcmsHubletPromise;
      if (resp && resp.ok) {
        const hublet = await resp.text();
        return hublet;
      }
    } catch (error) {
      // Fall through to make new request
    }
  }
  try {
    const resp = await fetch('/_hcms/hublet');
    if (!resp.ok) {
      throw new Error(`HTTP error. status: ${resp.status}`);
    }
    const hublet = await resp.text();
    return hublet;
  } catch (error) {
    Raven.captureMessage('Failed to fetch hublet for custom domain', {
      extra: error
    });
  }
}
export async function fetchEnvForCustomDomain() {
  if (window.__hcmsEnvPromise) {
    try {
      const resp = await window.__hcmsEnvPromise;
      if (resp && resp.ok) {
        const env = await resp.text();
        return env;
      }
    } catch (error) {
      // Fall through to make new request
    }
  }
  try {
    const resp = await fetch('/_hcms/env');
    if (!resp.ok) {
      throw new Error(`HTTP error. status: ${resp.status}`);
    }
    const env = await resp.text();
    return env;
  } catch (error) {
    Raven.captureMessage('Failed to fetch env for custom domain', {
      extra: error
    });
  }
}
export async function fetchHcmsDataForCustomDomain() {
  const [hublet, env] = await Promise.all([fetchHubletForCustomDomain(), fetchEnvForCustomDomain()]);
  return {
    hublet,
    env
  };
}